import { useMemo, useState } from "react";
import { LoadingView } from "../../../components";
import EnergyRatesList from "./EnergyRatesList";
import { IEnergyRate, energyRateModelId, schemaCO2Rate, schemaCostRate } from "./types";
import { Button } from "baseui/button";
import { VscAdd } from "react-icons/vsc";
import { AddEnergyRateModal } from ".";
import { CreateObjectInstanceCommand, useCreateObjectMutation, useGetObjectsInResourceGroupQuery } from "../../../services/objects";
import { EmptyState } from "../../../components/EmptyState";
import { FormattedMessage, useIntl } from "react-intl";


const EditableEnergyRatesList = (props: { resourceGroupId: string, canAddItems: boolean }) => {
    //const [selectedItem, setSeletctedItem] = useState<IEnergyRate>();
    const [isOpen, setIsOpen] = useState(false);
    const intl = useIntl();

    const { data, isLoading, isSuccess } = useGetObjectsInResourceGroupQuery({ resourceGroupId: props.resourceGroupId, queryParameters: `modelId=${energyRateModelId}` })
    //const handelItemSelected = (item: IEnergyRate) => setSeletctedItem(item);

   const items = useMemo(() => data?.slice().sort((a, b) => a.name.localeCompare(b.name)),[data])
    return (
        <>
            <LoadingView isLoading={isLoading} isSucess={isSuccess}>
                <EnergyRatesList items={items ?? []} ></EnergyRatesList>
                {(!items || items.length === 0) &&
                    <EmptyState header={intl.formatMessage({ id: "EditableEnergyRatesList.NoRates", defaultMessage: 'No energy rates found'})} message=" ">
                        <AddDefaultEnergyRatesButton resourceGroupId={props.resourceGroupId}></AddDefaultEnergyRatesButton>
                    </EmptyState>}
            </LoadingView>
            {props.canAddItems &&
                <>
                    <Button shape='circle' kind='primary' onClick={() => setIsOpen(true)} ><VscAdd></VscAdd></Button>
                    <AddEnergyRateModal resourceGroupId={props.resourceGroupId} isOpen={isOpen} onClose={() => setIsOpen(false)}></AddEnergyRateModal>
                </>
            }
        </>
    )
}

export default EditableEnergyRatesList;


const AddDefaultEnergyRatesButton = (props:{ resourceGroupId: string}) => {
    const [createObject, createObjectResult] = useCreateObjectMutation();

    const handelAddDefaultEntries = async () => {
        for (const elm of defaultItems) {
            const cmd: CreateObjectInstanceCommand = {
                name: elm.name,
                description: "",
                resourceGroupId: props.resourceGroupId,
                schema: elm.schema,
                properties: elm.properties
            }
            await createObject(cmd);
        }
    }

    return (
        <Button shape="pill" kind="secondary" onClick={handelAddDefaultEntries} isLoading={createObjectResult.isLoading}><FormattedMessage id="AddDefaultEnergyRatesButton.AddDefault" defaultMessage="Add default rates" /></Button>
    )
}

// TODO ,{ key: 'CurrencyCode', value: 'EUR'  } from country
// TODO Translation
const defaultItems: any[] = [
    { name: "Electricity", description: "", schema: schemaCostRate, properties: [{ key: 'ValuePerUnit', value: 0.3216  },{ key: 'CurrencyCode', value: 'EUR'  }] },
    { name: "Heating", description: "", schema: schemaCostRate, properties: [{ key: 'ValuePerUnit', value: 0.09  },{ key: 'CurrencyCode', value: 'EUR'  }] },
    { name: "Cooling", description: "", schema: schemaCostRate, properties: [{ key: 'ValuePerUnit', value: 0.17  },{ key: 'CurrencyCode', value: 'EUR'  }] },
    { name: "Water", description: "", schema: schemaCostRate, properties: [{ key: 'ValuePerUnit', value: 2.28  },{ key: 'CurrencyCode', value: 'EUR'  }] },

    { name: "Electricity CO2", description: "", schema: schemaCO2Rate, properties: [{ key: 'ValuePerUnit', value: 0.28  }]},
    { name: "Heating CO2", description: "", schema: schemaCO2Rate, properties: [{ key: 'ValuePerUnit', value:  0.311  }] },
    { name: "Cooling CO2", description: "", schema: schemaCO2Rate, properties: [{ key: 'ValuePerUnit', value:  0.311  }] },
    { name: "Water CO2", description: "", schema: schemaCO2Rate, properties: [{ key: 'ValuePerUnit', value:  0.0035  }] },
]

